import { Link } from "react-router-dom";
import "../styles/notFound.css";

const NotFound = () => (
  <main className="not-found" aria-labelledby="not-found-title">
    <div className="not-found__card">
      <p className="not-found__code">404</p>
      <h1 id="not-found-title">Page Not Found</h1>
      <p>
        The page you are looking for does not exist or may have been moved.
      </p>
      <Link className="not-found__home-link" to="/">
        Go to Home
      </Link>
    </div>
  </main>
);

export default NotFound;
